<div class="">
    @if (ShowHeader) {
<section class="mat-typography heading">
        <br>
        <h1>{{ navItems['Heading'] }}</h1>
    </section>
}
    @if (showSearch) {
<div class="search-input">
      <mat-form-field style="width: 80%">
        <mat-label>Search</mat-label>
        <input matInput [formControl]="searchControl">
      </mat-form-field>
    </div>
}
    <div class="padded-side-nav">
        @for (report of filteredItems | async; track report; let i = $index) {
<div class="outer-selection-nav">
          <div class="{{ report['MobileHidden'] ? 'hidden-on-mobile' : '' }}"></div>
                @if (report['Disabled'] === true) {
<mat-card matTooltip="coming soon..." class="navDiv res-text"><i class="material-icons pull-left">{{report['Icon']}}</i> {{ report['Description'] }}</mat-card>
}
                @if (!report['Disabled']) {
<mat-card
                   
                    (click)="navClicked(report);"
                    [routerLink]="report['Link']"
                    [queryParams]="report['Params']"
                    [matTooltip]="showTooltips ? report['Description'] : ''"
                    routerLinkActive="active"
                    class="navDiv res-text">
                    <div class="icon-container">
                      @if (!report['isImage']) {
<i class="material-icons">{{report['Icon']}}</i>
}
                      @if (report['isImage']) {
<img src="{{report.Icon}}.png">
}

                    </div>
                  <hr class="card-separator">
                  <div class="title-button-row">
                  <div class="item-title">{{ report['Description'] }} </div>
                  <div class="item-button">
                    <button mat-flat-button color="view"> View</button>
                  </div>
                  </div>

                    @if (report['Count'] != null) {
<div class="normal user-count">{{ report['Count'] }} online</div>
}
                    @if (report['loading'] === true) {
<mat-spinner class="mainSpinner" [diameter]="20"></mat-spinner>
}
                </mat-card>
}
            </div>
}
        @if (!items || items.length == 0) {
<div class="empty">
            <p>No navigable options to display.</p>
            <p>Please consult your user roles.</p>
        </div>
}
    </div>
</div>
